import { string } from 'prop-types'
import { useContext } from 'react'
import { MembershipContext, UserPHIContext } from 'ui/contexts'
import ProtectedRoute from '../ProtectedRoute'

const ProtectedByAdminOrPHI = ({ redirectPath }) => {
  const { admin } = useContext(MembershipContext)
  const phiVisibility = useContext(UserPHIContext)

  return (
    <ProtectedRoute
      isAllowed={admin || phiVisibility}
      redirectPath={redirectPath}
    />
  )
}

ProtectedByAdminOrPHI.propTypes = {
  redirectPath: string.isRequired,
}

ProtectedByAdminOrPHI.defaultProps = {}

export default ProtectedByAdminOrPHI
